import { render, staticRenderFns } from "./BoardMembers.vue?vue&type=template&id=7e73753a&scoped=true"
import script from "./BoardMembers.vue?vue&type=script&lang=js"
export * from "./BoardMembers.vue?vue&type=script&lang=js"
import style0 from "./BoardMembers.vue?vue&type=style&index=0&id=7e73753a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e73753a",
  null
  
)

export default component.exports